import { render } from "./TaskPopover.vue?vue&type=template&id=5125443a&scoped=true&ts=true"
import script from "./TaskPopover.vue?vue&type=script&lang=ts"
export * from "./TaskPopover.vue?vue&type=script&lang=ts"

import "./TaskPopover.vue?vue&type=style&index=0&id=5125443a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5125443a"]])

export default __exports__